export default "__VITE_ASSET__D3bC4Jwp__"